<template>
    <div class="service-reminders-container container-fluid">
        <search-component />

        <table-component v-if="reminders" />
    </div>
</template>

<script>
import UsesComments from "../../../mixins/UsesComments";
import UsesInfoMessage from "../../../mixins/UsesInfoMessage";
import TableComponent from "./TableComponent.vue";
import SearchComponent from "./SearchComponent.vue";
import { mapState } from "vuex";

export default {
    components: {
        SearchComponent,
        TableComponent,
    },
    mixins: [UsesComments, UsesInfoMessage],

    computed: {
        ...mapState("serviceReminders", [
            "reminders",
        ]),
    },
};
</script>

<style lang="scss" scoped>
.service-reminder {
    select {
        background: transparent;
        color: white;
        margin-bottom: 0.5rem;
    }
    &--booked {
        background: red;
        color: white;
    }

    &--ok {
        background: yellow;
        color: black;
    }

    &--done {
        background: green;
        color: white;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/office/service-reminders/IndexComponent.vue